@use 'sass:map';
@use '@helsenorge/designsystem-react/scss/breakpoints' as breakpoints;
@use '@helsenorge/designsystem-react/scss/spacers' as spacers;

$font-size: 1rem;
$font-weight: 600;
$text-color: #fffaf1;
$background-color: #5c2e91;

.container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  width: 95%;
  margin-bottom: 15px;
}

.text {
  font-weight: $font-weight;
  font-size: $font-size;
  color: $text-color;
  line-height: 2.8rem;
  margin: 0;
}

.buttonFilled,
.buttonOutlined {
  display: inline-block;
  padding: 5px 15px;
  text-decoration: none;
  border-radius: 20px;
  font-weight: $font-weight;
  font-size: $font-size;
  cursor: pointer;
  transition: all 0.2s;
}

.buttonFilled {
  background-color: white;
  color: $background-color;
  border: 2px solid white;
}

.buttonOutlined {
  background-color: transparent;
  color: white;
  border: 2px solid white;
}
